// p220 table pagination: показывает оверлей на таблице при пагинации через Turbo Frame.
// Навешивается на <turbo-frame> — слушает клики по ссылкам пагинации.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this._onFrameLoad = this.onFrameLoad.bind(this)
    this._onFrameRender = this.onFrameRender.bind(this)

    this.element.addEventListener("click", this.onClick.bind(this))
    this.element.addEventListener("turbo:frame-load", this._onFrameLoad)
    this.element.addEventListener("turbo:frame-render", this._onFrameRender)

    // На случай snapshot restore
    this.hideOverlay()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this._onFrameLoad)
    this.element.removeEventListener("turbo:frame-render", this._onFrameRender)
  }

  onClick(event) {
    // Только клик по ссылке пагинации (data-turbo-frame)
    const link = event.target.closest('a[data-turbo-frame]')
    if (!link) return
    const frameId = link.getAttribute('data-turbo-frame')
    if (frameId !== this.element.id) return

    this.showOverlay()
  }

  onFrameLoad(event) {
    this.hideOverlay()
  }

  onFrameRender(event) {
    this.hideOverlay()
  }

  showOverlay() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("hidden")
  }

  hideOverlay() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
  }
}
